











import { Component, Vue, Prop } from 'vue-property-decorator'
import { RoomMember } from '@/class/roomMember'
import { Game } from '@/class/game'
import { Chat } from '@/class/chat'
import ChatLogViewer from './ChatLogViewer.vue'
import ChatForm from './ChatForm.vue'
import Marquee from './Marquee.vue'
import BtnSquare from '@/components/Utils/form/button/BtnSquare.vue'

@Component({
  components: {
    ChatLogViewer,
    ChatForm,
    Marquee,
    BtnSquare
  }
})
export default class ChatWindow extends Vue {
  @Prop() game!: Game;
  @Prop() self!: RoomMember;
  @Prop() isGallary!: boolean;
  chat = new Chat(this.game.roomId, this.game.id);
  size: 'none' | 'low' | 'high' = 'none';
  isFlash = false

  created () {

  this.$watch('logCount', (now, prev) => {
      if (now !== prev) {
        this.isFlash = true
        setTimeout(() => this.isFlash = false, 1000)
      }
    })
  }

  changeWindowSize () {
    if (this.size === 'none') {
      this.size = 'low'
    } else if (this.size === 'low') {
      this.size = 'high'
    } else {
      this.size = 'none'
    }
  }

  get sizeClass () {
    return { [this.size]: true }
  }

  get logCount () {
    return this.chat.logs.length
  }

  send (text: string) {
    this.chat.saveMessage(this.self.name, text)
  }
}
